import React from 'react'

export interface CheckboxListProps {
	items: React.ReactNode[]
}

export const CheckboxList: React.FunctionComponent<CheckboxListProps> = ({
	items,
}) => (
	<div
		className="checkboxList"
		style={{
			['--checkboxList-column-count' as any]: Math.ceil(items.length / 20),
		}}
	>
		{items.length === 0 ? (
			<div className="checkboxList-empty">Není na výběr žádná možnost</div>
		) : (
			<ul className="checkboxList-items">
				{items.map((item, i) => (
					<li className="checkboxList-item" key={i}>
						{item}
					</li>
				))}
			</ul>
		)}
	</div>
)
